import React, { FC } from 'react';
import { Col, FormGroup, FormLabel } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import TextInput from '../../../../../../components/library/inputs/text/TextInput';

interface Props {
  label: string;
  value: string | undefined;
  onChange: (event: string) => void;
  size?: number;
  readOnlyMode?: boolean;
}

const TextSetting: FC<Props> = ({ label, value, onChange, size = 12, readOnlyMode = false }: Props) => {
  return (
    <FormGroup className={'form-group'} as={Col} md={size}>
      <FormLabel>
        <FormattedMessage id={label} />
      </FormLabel>
      <TextInput onChange={(e) => onChange(e.target.value)} value={value} readOnlyMode={readOnlyMode} />
    </FormGroup>
  );
};

export default TextSetting;
